import { displaySlice } from '../displaySlice';

export const { setDisplay } = displaySlice.actions;
export const { setModal } = displaySlice.actions;
export const { setIsLoaded } = displaySlice.actions;
